import { Injectable, inject } from '@angular/core';
import { SQLite, SQLiteObject } from '@awesome-cordova-plugins/sqlite/ngx';
import { PluginHelperService } from '../plugins';

const DB = 'logging_database.db';
const LOGGING_TABLE = 'loggingTable';
const UBIE_TABLE = 'ubie';
const CASCHING_TABLE = 'caching';

@Injectable()
export class StorageService {
  private readonly sqlite = inject(SQLite);
  private readonly pluginHelper = inject(PluginHelperService);

  databaseObj?: SQLiteObject;

  name_model = '';
  row_data: any = [];

  currentId = 0;

  // Handle Update Row Operation
  updateActive?: boolean;
  to_update_item: any;

  constructor() {
    this.createDB();
  }

  // Create DB if not there
  createDB() {
    if (!this.pluginHelper.isNative()) return;

    try {
      this.sqlite
        .create({
          name: DB,
          location: 'default',
        })
        .then((db: SQLiteObject) => {
          this.databaseObj = db;
          //alert('datatable Database Created!');
          console.error('database created');

          this.createLogTable();
          this.createCacheTable();
          this.createUbieTable();
        })
        .catch((e) => {
          console.error('error ' + JSON.stringify(e));
        });
    } catch (err) {
      console.error(err);
    }
  }

  createCacheTable() {
    this.databaseObj
      ?.executeSql(
        `
    CREATE TABLE IF NOT EXISTS ${CASCHING_TABLE}  (ID INTEGER PRIMARY KEY, apiUrl TEXT NOT NULL UNIQUE, jsonData TEXT);
  
    `,
        []
      )
      .then(() => {
        this.insertRow('Cache table created');
      })
      .catch((e) => {
        console.error('error ' + JSON.stringify(e));
      });
  }

  createUbieTable() {
    this.databaseObj
      ?.executeSql(
        `
    CREATE TABLE IF NOT EXISTS ${UBIE_TABLE}  (ID INTEGER PRIMARY KEY, SerialNumber TEXT NOT NULL UNIQUE, Ip TEXT, Username TEXT, Password TEXT, Dns TEXT, Gateway TEXT, Subnet TEXT);
  
    `,
        []
      )
      .then(() => {
        this.insertRow('Ubie table created');
      })
      .catch((e) => {
        console.error('error ' + JSON.stringify(e));
      });
  }

  // Create table
  createLogTable() {
    this.databaseObj
      ?.executeSql(
        `
    CREATE TABLE IF NOT EXISTS ${LOGGING_TABLE}  (pid INTEGER PRIMARY KEY, Name TEXT);
  
    `,
        []
      )
      .then(() => {
        this.insertRow('Log Table created');
      })
      .catch((e) => {
        console.error('error ' + JSON.stringify(e));
      });
  }

  executeSql(sql: string, params: any[]) {
    this.databaseObj
      ?.executeSql(sql, params)
      .then()
      .catch((err) => console.error('STORAGE execute error: ' + err));
  }

  async executeGetSql(sql: string, params: any[]): Promise<any> {
    const row_data = [];
    const res = await this.databaseObj?.executeSql(sql, params);

    if (res.rows.length > 0) {
      for (let i = 0; i < res.rows.length; i++) {
        row_data.push(res.rows.item(i));
      }
      return row_data;
    }
    return null;
  }

  deleteTooManyRows() {
    const sql = `DELETE FROM ${LOGGING_TABLE}  where ROWID NOT IN (SELECT ROWID rn FROM ${LOGGING_TABLE}  ORDER BY pid DESC  LIMIT 2000);`;
    this.databaseObj
      ?.executeSql(sql, [])
      .then()
      .catch((e) => {
        console.error('error ' + JSON.stringify(e));
      });
  }

  //Inset row in the table
  insertRow(value: string) {
    this.databaseObj
      ?.executeSql(
        `
      INSERT INTO ${LOGGING_TABLE} (Name) VALUES ('${value}'); 
    `,
        []
      )
      .then()
      .catch((e) => {
        console.error('error ' + JSON.stringify(e));
      });

    this.currentId++;

    if (this.currentId >= 100) {
      this.currentId = 0;
      this.deleteTooManyRows();
    }
  }

  async getUbieRows(): Promise<any> {
    this.row_data = [];
    const res = await this.databaseObj?.executeSql(
      `
        SELECT * FROM ${UBIE_TABLE}
        `,
      []
    );

    if (res.rows.length > 0) {
      for (let i = 0; i < res.rows.length; i++) {
        this.row_data.push(res.rows.item(i));
      }
    }

    return this.row_data;
  }

  // Retrieve rows from table
  async getRows(): Promise<any> {
    this.row_data = [];
    const res = await this.databaseObj?.executeSql(
      `
        SELECT * FROM ${LOGGING_TABLE}
         ORDER BY pid DESC  LIMIT 2000`,
      []
    );

    if (res.rows.length > 0) {
      for (let i = 0; i < res.rows.length; i++) {
        this.row_data.push(res.rows.item(i));
      }
    }

    return this.row_data;
  }

  // Delete single row
  deleteRow(item: any) {
    this.databaseObj
      ?.executeSql(
        `
      DELETE FROM ${LOGGING_TABLE} WHERE pid = ${item.pid}
    `,
        []
      )
      .then((res) => {
        alert('Row Deleted!');
        this.getRows();
      })
      .catch((e) => {
        alert('error ' + JSON.stringify(e));
      });
  }

  // Delete all rows
  deleteRows() {
    this.databaseObj
      ?.executeSql(
        `
    DELETE FROM ${LOGGING_TABLE}
  `,
        []
      )
      .then()
      .catch((e) => {
        console.error('error ' + JSON.stringify(e));
      });
  }

  // Enable update mode and keep row data in a variable
  enableUpdate(item: any) {
    this.updateActive = true;
    this.to_update_item = item;
    this.name_model = item.Name;
  }

  // Update row with saved row id
  updateRow() {
    this.databaseObj
      ?.executeSql(
        `
      UPDATE ${LOGGING_TABLE}
      SET Name = '${this.name_model}'
      WHERE pid = ${this.to_update_item.pid}
    `,
        []
      )
      .then(() => {
        alert('Row Updated!');
        this.updateActive = false;
        this.getRows();
      })
      .catch((e) => {
        alert('error ' + JSON.stringify(e));
      });
  }
}
